import React from "react";
import { PartnersSection, Title } from "./style";
import { GlobalContainer } from "../../../Global/layout";

const Partners = ({ data }: any) => {
  return (
    <section className="light">
      <PartnersSection>
        <GlobalContainer>
          <Title data-aos="fade-up">{data?.heading}</Title>
          <div className="logo-container" data-aos="fade-up">
            {data?.servicesCta?.map((item: any, index: number) => {
              return (
                <div className="logo" key={index}>
                  <img
                    src={item.image?.mediaItemUrl}
                    alt={item.image?.altText}
                  />
                </div>
              );
            })}
          </div>
        </GlobalContainer>
      </PartnersSection>
    </section>
  );
};

export default Partners;
